import { useInfiniteQuery } from '../use-query';
import { extendContainerValidator } from '../../utils';
import { containersService } from '../../services';
import { TABLE } from '../../const';

export const useContainersQuery = (keys: any = {}) => {
  const containerNumber = keys.number;

  if (keys.number?.length < 3 || !extendContainerValidator(keys.number)) {
    delete keys.number;
  }

  if (keys.imageType === 'all') {
    delete keys.imageType;
  } else if (keys.imageType === 'hasImages') {
    keys.imageType = true;
  } else if (keys.imageType === 'noImages') {
    keys.imageType = false;
  }

  const result = useInfiniteQuery(
    ['containers', JSON.stringify(keys)],
    ({ pageParam = 0 }) =>
      containersService.options({
        ...keys,
        take: TABLE.PAGE_MAX_SIZE,
        skip: pageParam * TABLE.PAGE_MAX_SIZE,
        notLoading: true,
        pageParam,
      })(),
    {
      getNextPageParam: (data: any) => {
        const loaded = (data.pageParam + 1) * TABLE.PAGE_MAX_SIZE;
        return loaded < data.totalCount ? data.pageParam + 1 : undefined;
      },
      select: (data: any) => ({
        ...data,
        data: data.pages.flatMap((page: any) => page.data),
        totalCount: data.pages[0]?.totalCount ?? 0,
      }),
      keepPreviousData: false,
    },
  );

  if (result && result.data) {
    result.data.data = result.data?.data?.filter((obj: any) => obj.label.includes(containerNumber));
  }

  return { ...result, data: result?.data || { data: [], totalCount: 0 } };
};
